export default __webpack_public_path__ + "static/media/wave.8df4b01c.png";